import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setInvoiceSumFormAction } from "../../redux/rootReducer";
import { INVOICE_SUM_FORM_INITIAL } from "../../redux/initialStateConstant";
import { UpdateInvoiceSumThunk } from "../../redux/thunks/UpdateInvoiceSumThunk";
import { RemoveInvoiceThunk } from "../../redux/thunks/RemoveInvoiceThunk";
import Tippy from "@tippyjs/react";
import growl from "../../lib/growl/growl";

const InvoiceSumForm = () => {
    const dispatch = useDispatch();
    const invoice_sum_form = useSelector(state => state.invoice_sum_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setInvoiceSumFormAction(INVOICE_SUM_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">{ `Счёт № ${ invoice_sum_form.invoice_id }` }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Сумма счёта</div>
                        <input type="text" className="input"
                            value={ invoice_sum_form.sum }
                            onInput={ event => {
                                dispatch(setInvoiceSumFormAction({
                                    ...invoice_sum_form,
                                    sum: event.target.value
                                }));
                            } }
                        />
                    </div>

                    <div className="form__field">
                        <div className="input__caption">Наименование услуги</div>
                        <div className="setting__ico-wrapper">
                            <Tippy content={ 'Скопировать наименование услуги' }>
                                <div className="setting__ico setting__ico--copy"
                                     onClick={ () => {
                                         navigator.clipboard.writeText('Автоматизация бизнес-процессов');
                                         growl({ type: 'success', message: 'Скопировано' });
                                     } }
                                />
                            </Tippy>
                        </div>
                        <div className="input input--copy">{ 'Автоматизация бизнес-процессов' }</div>
                    </div>

                    <div className="form__field">
                        <div className="input__caption">УНП контрагента</div>
                        <div className="setting__ico-wrapper">
                            <Tippy content={ 'Скопировать УНП' }>
                                <div className="setting__ico setting__ico--copy"
                                     onClick={ () => {
                                         navigator.clipboard.writeText(invoice_sum_form.unp);
                                         growl({ type: 'success', message: 'Скопировано' });
                                     } }
                                />
                            </Tippy>
                        </div>
                        <div className="input input--copy">{ invoice_sum_form.unp }</div>
                    </div>

                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(UpdateInvoiceSumThunk({
                                    invoice_id: invoice_sum_form.invoice_id,
                                    sum: invoice_sum_form.sum
                                }));
                            } }
                        >Сохранить</div>
                    </div>

                    <div className="form__field">
                        <div className="button button--red"
                            onClick={ () => {
                                if (!window.confirm('Вы действительно хотите удалить счёт?')) return;

                                dispatch(RemoveInvoiceThunk({ invoice_id: invoice_sum_form.invoice_id }));
                            } }
                        >Удалить счёт</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceSumForm;